import { terms } from 'lib/terms'

import { TermsLayout } from 'components/v2/TermsLayout/TermsLayout'

const TermsPsychologist = ({ content }) => {
	const metaTags = {
		title: 'Psicólogo Leia os Termos de Uso | Vittude',
		description:
			'Estes termos de uso vai apresentar quais são as condições, diretrizes, políticas e deveres que definem a relação entre você, psicólogo e a Vittude.'
	}

	return <TermsLayout content={content} metaTags={metaTags} />
}

export async function getStaticProps() {
	const content = await terms('termos-uso-psicologos.md')

	return {
		props: {
			content
		}
	}
}

export default TermsPsychologist
